<template lang="pug">
.vipOpen
  .vipOpen-box(v-if="!isLogin")
    img.vipOpen-box-profile(src="@/assets/imgs/profile-no_login.png")
    .vipOpen-box-status.color_text_vip_2.common_font_1 未登录
    .vipOpen-box-content.common_font_1 解锁学习办公最佳翻译搭档
    .vipOpen-box-btn.common_font_1(@click="open") 立即开通
  .vipOpen-box(v-else-if="!isSVip")
    img.vipOpen-box-profile(:src="userInfo.userAvatar")
    .vipOpen-box-status.color_text_vip_2.common_font_1 hi，{{userInfo.userName}}
    .vipOpen-box-content.common_font_1 解锁学习办公最佳翻译搭档
    .vipOpen-box-btn.common_font_1(@click="open") 立即开通
  .vipOpen-box(v-else)
    img.vipOpen-box-profile(:src="userInfo.userAvatar")
    .vipOpen-box-status.color_text_vip_2.common_font_1 hi，{{userInfo.userName}}
    .vipOpen-box-content.common_font_1 {{userInfo.svipExpire}}到期
    .vipOpen-box-btn.common_font_1(@click="open") 立即续费
</template>

<script>
import request from '@/service/login/index';
import vip from '@/service/vip';
import util from '@/util';

export default {
  name: 'VipOpen',
  data() {
    return {
      isLogin: false,
      isSVip: false,
      yduserid: '',
      userInfo: {
        userAvatar: '', // 用户头像
        userName: '',
        svipExpire: '',
      },
      showBuyVip: false,
    };
  },
  mounted() {
    this.getAccountInfo();
  },
  methods: {
    getAccountInfo() {
      request.getAccountInfos().then((res) => {
        if (res.code === 0) {
          this.isLogin = true;
          this.yduserid = res.data.yduserid;
          this.getBatchData(this.yduserid);
          this.getVipStatus();
        } else {
          this.isLogin = false;
        }
      });
    },
    getBatchData(userid) {
      const params = {
        userid,
      };
      request.getBatchUrl(params).then((res) => {
        this.userInfo.userName = res.values.nickname;
        this.userInfo.userAvatar = res.values.option_avatar;
      });
    },
    getVipStatus() {
      const param = {
        imei: '1',
        keyfrom: 'webdict',
        apiversion: '1.0',
        product: '',
      };
      vip.getVipStatus(param).then((res) => {
        this.isSVip = res.svip;
        this.userInfo.svipExpire = res.svipExpire;
        if (this.userInfo.svipExpire) {
          this.userInfo.svipExpire = util.dateFormat(
            'yyyy-MM-dd',
            new Date(this.userInfo.svipExpire),
          );
        }
      });
    },
    open() {
      this.$emit('goBuy');
    },
  },
};
</script>

<style lang="stylus" scoped>
.vipOpen
  width 1200px
  height 100%
  position absolute
  top 0
  margin 0 auto
  left 50%
  transform translateX(-50%)
  .vipOpen-box
    width 268px
    height 180px
    border-radius 16px
    position absolute
    right 0
    top 28px
    bottom 0
    margin auto
    background url('~@/assets/imgs/vip/light/nologin_bg.png') 0 0 / 100% no-repeat
    .vipOpen-box-profile
      // background url('~@/assets/imgs/profile-no_login.png') 0 0 / 100% no-repeat
      width 56px
      height 56px
      position absolute
      left 0
      right 0
      margin auto
      border-radius 50%
      transform translateY(-50%)
    .vipOpen-box-status
      position absolute
      width 90%
      height 21px
      left 0
      right 0
      top 47px
      margin auto
      font-style normal
      font-weight 600
      font-size 18px
      line-height 21px
      color #8F6339
      text-align center
      overflow hidden
      text-overflow ellipsis
      white-space nowrap
    .vipOpen-box-content
      @extend .vipOpen-box-status
      width 186px
      top 73px
      font-weight 400
      font-size 12px
      line-height 14px
    .vipOpen-box-btn
      @extend .vipOpen-box-status
      width 212px
      height 46px
      top 106px
      background #593712
      border-radius 100px
      font-size 14px
      line-height 46px
      text-align center
      color #FFEFE0
      cursor pointer
</style>
